import general from "./general";
import user from "./user";
import doctor from "./doctor";
import address from "./address";
import auth from "./auth";
import error from "./error";
import validation from "./validation";
import navigation from "./navigation";
import holiday from "./holiday";
import numbers from "./numbers";
import role from "./role";
import hint from "./hint";
import service from "./service";
import insurance from "./insurance";
import section from "./section";
import unit from "./unit";
import room from "./room";
import bed from "./bed";
import discountGroup from "./discountGroup";
import toastification from "./toastification";
import pagination from "./pagination";
import currency from "./currency";
import config from "./config";
import generalInformation from "./medical-records/infertility/generalInformation";
import pastHistory from "./medical-records/infertility/pastHistory";
import pastObstetricHistory from "./medical-records/infertility/pastObstetricHistory";
import previousFertilityTreatments from "./medical-records/infertility/previousFertilityTreatments";
import addiction from "./medical-records/infertility/addiction/addiction";
import referralNote from "./medical-records/infertility/referralNote";
import sfa from "./medical-records/infertility/sfa/sfa";
import dfa from "./medical-records/infertility/dfa/dfa";
import summaryAndPlan from "./medical-records/infertility/summaryAndPlan";
import secondVisit from "./medical-records/infertility/secondVisit";
import familyRelationship from "./base-informations/familyRelationship";
import bloodType from "./base-informations/bloodType";
import contraceptive from "./base-informations/contraceptive";
import disease from "./base-informations/disease";
import surgeryCategory from "./base-informations/surgeryCategory";
import surgery from "./base-informations/surgery";
import radiologyTest from "./base-informations/radiologyTest";
import medication from "./base-informations/medication";
import pregnancyMethod from "./base-informations/pregnancyMethod";
import parityType from "./base-informations/parityType";
import abortionType from "./base-informations/abortionType";
import abortionMethod from "./base-informations/abortionMethod";
import ivfMethod from "./base-informations/ivfMethod";
import transferOperationType from "./base-informations/transferOperationType";
import ioMethod from "./base-informations/ioMethod";
import allergyCrud from "./base-informations/allergy";
import addictionCrud from "./base-informations/addiction";
import accountGroups from "./accountGroups";
import totalAccount from "./totalAccount";
import subsidiaryAccounts from "./subsidiaryAccounts";
import detailAccount from "./detailAccount";
import referral from "./referral";
import reception from "./reception";
import pose from "./pose";
import indications from "./indications";
import medicalAbbreviationTests from "./medicalAbbreviationTests";
import cardiacActivities from "./base-informations/cardiacActivities";
import impressionLocations from "./base-informations/impressionLocations";
import bladderNodules from "./base-informations/bladderNodules";
import uterusAdenomyosisTests from "./base-informations/uterusAdenomyosisTests";
import dopplerStudyTypes from "./base-informations/dopplerStudyTypes";
import tendernessWithTheProbeTypes from "./base-informations/tendernessWithTheProbeTypes";
import cervicalLength from "./medical-records/infertility/sonography-items/cervicalLength";
import endometriosisPelvicUs from "./medical-records/infertility/sonography-items/endometriosisPelvicUs";
import fet from "./medical-records/infertility/sonography-items/fet";
import follicleTracking from "./medical-records/infertility/sonography-items/follicleTracking";
import reports from "./reports";
import pelvicUltrasoundExamination from "./medical-records/infertility/sonography-items/pelvicUltrasoundExamination";
import pregnancy from "./medical-records/infertility/sonography-items/pregnancy";
import tripletEarlyPregnancy from "./medical-records/infertility/sonography-items/tripletEarlyPregnancy";
import twinEarlyPregnancy from "./medical-records/infertility/sonography-items/twinEarlyPregnancy";
import medicalSpecialties from "./base-informations/medicalSpecialties";
import permissions from "./base-informations/permissions";
import medicalScientificDegrees from "./base-informations/medicalScientificDegrees";
import banks from "./base-informations/banks";
import serviceGroups from "./base-informations/serviceGroups";
import antenatalCareTest from "./medical-records/obstetric/antenatalCareTest";
import cSectionOperation from "./medical-records/obstetric/cSectionOperation";
import internalPhysicalExam from "./medical-records/glands/internalPhysicalExam";
import pGDForGenderDetermination from "./medical-records/genetics/pGDForGenderDetermination";
import pGDForDisease from "./medical-records/genetics/pGDForDisease";
import countries from "./base-informations/countries";
import provinces from "./base-informations/provinces";
import cities from "./base-informations/cities";
import pGSGenetics from "./medical-records/genetics/pGSGenetics";
import educationalDegree from "./educationalDegree";
import uploader from "./uploader";
import serviceCategories from "./base-informations/serviceCategories";
import anthropometry from "./medical-records/nourish/anthropometry";
import nourishRecallRecord from "./medical-records/nourish/nourishRecallRecord";
import ffq from "./medical-records/nourish/ffq";
import specialConditionsAndFood from "./medical-records/nourish/specialConditionsAndFood";
import finalOpinionsOfANutritionist from "./medical-records/nourish/finalOpinionsOfANutritionist";
import urologyPhysicalExam from "./medical-records/urology/urologyPhysicalExam";
import urologyPlan from "./medical-records/urology/urologyPlan";
import legalVisit from "./medical-records/legal/legalVisit";
import reasonOfReferences from "./base-informations/reasonOfReferences";
import permissionRooms from "./base-informations/permissionRooms";
import permissionUnits from "./base-informations/permissionUnits";
import settings from "./settings";

export default {
  general,
  doctor,
  user,
  address,
  auth,
  error,
  validation,
  navigation,
  holiday,
  numbers,
  role,
  hint,
  service,
  insurance,
  section,
  unit,
  room,
  bed,
  discountGroup,
  toastification,
  pagination,
  currency,
  config,
  generalInformation,
  pastHistory,
  pastObstetricHistory,
  previousFertilityTreatments,
  addiction,
  referralNote,
  sfa,
  dfa,
  summaryAndPlan,
  secondVisit,
  familyRelationship,
  bloodType,
  contraceptive,
  disease,
  surgeryCategory,
  surgery,
  radiologyTest,
  medication,
  pregnancyMethod,
  parityType,
  abortionType,
  abortionMethod,
  ivfMethod,
  transferOperationType,
  ioMethod,
  allergyCrud,
  addictionCrud,
  accountGroups,
  totalAccount,
  subsidiaryAccounts,
  detailAccount,
  referral,
  reception,
  pose,
  indications,
  medicalAbbreviationTests,
  cardiacActivities,
  impressionLocations,
  bladderNodules,
  uterusAdenomyosisTests,
  dopplerStudyTypes,
  tendernessWithTheProbeTypes,
  cervicalLength,
  endometriosisPelvicUs,
  fet,
  follicleTracking,
  reports,
  pelvicUltrasoundExamination,
  pregnancy,
  tripletEarlyPregnancy,
  twinEarlyPregnancy,
  medicalSpecialties,
  permissions,
  medicalScientificDegrees,
  banks,
  serviceGroups,
  antenatalCareTest,
  cSectionOperation,
  internalPhysicalExam,
  pGDForGenderDetermination,
  pGDForDisease,
  countries,
  provinces,
  cities,
  pGSGenetics,
  educationalDegree,
  uploader,
  serviceCategories,
  anthropometry,
  nourishRecallRecord,
  ffq,
  specialConditionsAndFood,
  finalOpinionsOfANutritionist,
  urologyPhysicalExam,
  urologyPlan,
  legalVisit,
  reasonOfReferences,
  permissionRooms,
  permissionUnits,
  settings
};
